/**
 * Service layer for the flag-ON Attachments wizard step (IP-15551 task-10).
 * Communicates with the Proposals::AttachmentsController JSON endpoints.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from '@utils/axios';
// ─── Mappers ────────────────────────────────────────────────────────────────
function mapItem(raw) {
    return {
        id: raw.id,
        recordId: raw.record_id,
        sourceKind: raw.source_kind,
        name: raw.name,
        typeLabel: raw.type_label,
        previewUrl: raw.preview_url,
        downloadUrl: raw.download_url,
        reportId: raw.report_id,
        workOrderPhotoId: raw.work_order_photo_id,
        deficiencyPhotoId: raw.deficiency_photo_id
    };
}
function mapBuildingPhoto(raw) {
    var _a, _b;
    return {
        id: raw.id,
        photoType: raw.photo_type,
        name: raw.name,
        previewUrl: raw.preview_url,
        dateTaken: raw.date_taken,
        caption: raw.caption,
        related: raw.related,
        typeLabel: raw.type_label,
        uploadedBy: { name: (_a = raw.uploaded_by) === null || _a === void 0 ? void 0 : _a.name, avatarUrl: (_b = raw.uploaded_by) === null || _b === void 0 ? void 0 : _b.avatar_url }
    };
}
function mapInspectionReport(raw) {
    return {
        id: raw.id,
        inspectionDate: raw.inspection_date,
        date: raw.date,
        buildingName: raw.building_name,
        systemAsset: raw.system_asset,
        displayName: raw.display_name,
        linked: raw.linked,
        pdfUrl: raw.pdf_url
    };
}
// ─── API calls ──────────────────────────────────────────────────────────────
export function fetchAttachmentsList(url) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.get(url);
        return response.data.items.map(mapItem);
    });
}
export function fetchBuildingPhotos(url) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.get(url);
        return response.data.photos.map(mapBuildingPhoto);
    });
}
export function fetchInspectionReports(url) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.get(url);
        return response.data.reports.map(mapInspectionReport);
    });
}
export function attachBuildingPhoto(url, photoType, photoId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield api.post(url, { photo_type: photoType, photo_id: photoId });
    });
}
export function detachBuildingPhoto(url, deficiencyPhotoId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield api.delete(url, { data: { deficiency_photo_id: deficiencyPhotoId } });
    });
}
export function detachWorkOrderPhoto(url, workOrderPhotoId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield api.delete(url, { data: { work_order_photo_id: workOrderPhotoId } });
    });
}
export function deleteProposalPhoto(url, proposalPhotoId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield api.delete(url, { data: { proposal_photo_id: proposalPhotoId } });
    });
}
export function deleteProposalAttachment(baseUrl, attachmentId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield api.delete(`${baseUrl}/${attachmentId}`);
    });
}
export function addReport(url, reportId, proposalId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield api.post(url, { report_id: reportId, proposal_id: proposalId });
    });
}
export function removeReport(url, reportId, proposalId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield api.delete(url, { data: { report_id: reportId, proposal_id: proposalId } });
    });
}
export function uploadFile(url, file, csrfToken) {
    return __awaiter(this, void 0, void 0, function* () {
        const form = new FormData();
        form.append('proposal_attachment[attached_file]', file);
        form.append('proposal_attachment[name]', file.name);
        yield api.post(url, form, {
            headers: {
                'X-CSRF-Token': csrfToken
            }
        });
    });
}
